import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getClosedProperties } from '../../Redux/Actions/actions';
import CardBalanceAdmin from '../CardBalanceAdmin/CardBalanceAdmin';
import FilterForm from './FilterCardBalance/FilterCardBalance';
import CreateSaleModal from './CreateSaleModal/CreateSaleModal'; // Importar el modal
import style from './CardBalanceAdminContainer.module.css';

const CardBalanceAdminContainer = ({ closedProperties, getClosedProperties }) => {
  const [balances, setBalances] = useState({
    totalCerradas: 0,
    cerradasPorAgente: 0,
    cerradasPorOtras: 0,
    puntaCompradora: 0,
    puntaVendedora: 0,
    puntaAmbas: 0,
    comisiones: {},
  });

  const [showModal, setShowModal] = useState(false); // Estado para mostrar/ocultar el modal

  useEffect(() => {
    getClosedProperties({});
  }, [getClosedProperties]);

  useEffect(() => {
    if (!closedProperties || closedProperties.length === 0) return;

    let cerradasPorAgente = 0;
    let cerradasPorOtras = 0;
    let puntaCompradora = 0;
    let puntaVendedora = 0;
    let puntaAmbas = 0;

    let comisiones = {}; // Objeto para almacenar comisiones por moneda

    closedProperties.forEach((property) => {
      const cerrado = property?.cerrado;
      if (!cerrado) return;

      // Contadores de cierres
      if (cerrado.soldByAgent) cerradasPorAgente++;
      if (cerrado.soldByAgent === false) cerradasPorOtras++;
      if (cerrado.buyingTip && cerrado.selleringTip) {
        puntaAmbas++;
      } else {
        if (cerrado.buyingTip) puntaCompradora++;
        if (cerrado.selleringTip) puntaVendedora++;
      }

      // Manejo de comisiones por moneda
      const currency = cerrado.currencyCierre || "USD"; // Si no tiene currencyCierre, asumimos USD
      if (!comisiones[currency]) {
        comisiones[currency] = {
          sellerCommision: 0,
          officeComission: 0,
          totalComission: 0,
          franquiciaComission: 0,
          martillerComission: 0,
        };
      }

      // Sumar comisiones si existen
      comisiones[currency].sellerCommision += parseFloat(cerrado.sellerCommision) || 0;
      comisiones[currency].officeComission += parseFloat(cerrado.officeComission) || 0;
      comisiones[currency].totalComission += parseFloat(cerrado.totalComission) || 0;
      comisiones[currency].franquiciaComission += parseFloat(cerrado.franquiciaComission) || 0;
      comisiones[currency].martillerComission += parseFloat(cerrado.martillerComission) || 0;
    });

    setBalances({
      totalCerradas: closedProperties.length,
      cerradasPorAgente,
      cerradasPorOtras,
      puntaCompradora,
      puntaVendedora,
      puntaAmbas,
      comisiones,
    });

  }, [closedProperties]);

  const handleFilter = (filters) => {
    getClosedProperties(filters);
  };

  const handleCreateSale = (formData) => {
    console.log('Datos enviados al backend:', formData);
    // Aquí puedes llamar a la acción para enviar los datos al backend
  };

  if (!closedProperties) {
    return <div>Cargando propiedades...</div>;
  }

  if (closedProperties.length === 0) {
    return <div>No hay propiedades cerradas.</div>;
  }

  const formatPrice = (price) => {
    return price.toLocaleString('es-AR'); // Formato de número con separadores de miles
  };

  console.log(closedProperties);
  
  return (
    <div>
      <h3 className={style.title}>Cantidad: {balances.totalCerradas} Publicaciones Cerradas</h3>

      {/* Formulario de Filtros */}
      <FilterForm onFilter={handleFilter} />

      {/* Botón para abrir el modal */}
      <button className={style.createButton} onClick={() => setShowModal(true)}>
        Crear Nueva Venta
      </button>

      {/* Modal */}
      <CreateSaleModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleCreateSale}
      />

        {/* Tabla de balances */}
        <div className={style.tableContainer}>
        <h4>Balances Generales</h4>
        <table className={style.table}>
          <thead>
            <tr>
              <th>Cerradas por Agente</th>
              <th>Cerradas por Otra Inmobiliaria</th>
              <th>Punta Compradora</th>
              <th>Punta Vendedora</th>
              <th>Punta Compradora y Vendedora</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{balances.cerradasPorAgente}</td>
              <td>{balances.cerradasPorOtras}</td>
              <td>{balances.puntaCompradora}</td>
              <td>{balances.puntaVendedora}</td>
              <td>{balances.puntaAmbas}</td>
            </tr>
          </tbody>
        </table>

        <h4>Comisiones Generadas</h4>
        <table className={style.table}>
          <thead>
            <tr>
              <th>Moneda</th>
              <th>Comisión Vendedor</th>
              <th>Comisión Oficina</th>
              <th>Comisión Total</th>
              <th>Comisión Franquicia</th>
              <th>Comisión Martillero</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(balances.comisiones).map(([currency, comision]) => (
              <tr key={currency}>
                <td>{currency}</td>
                <td>{comision.sellerCommision.toLocaleString('es-AR')}</td>
                <td>{comision.officeComission.toLocaleString('es-AR')}</td>
                <td>{comision.totalComission.toLocaleString('es-AR')}</td>
                <td>{comision.franquiciaComission.toLocaleString('es-AR')}</td>
                <td>{comision.martillerComission.toLocaleString('es-AR')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Listado de propiedades cerradas */}
      <div className="card-deck">
        {closedProperties.map((property) => (
          <CardBalanceAdmin key={property.id} property={property} />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  closedProperties: state.closedProperties,
});

export default connect(mapStateToProps, { getClosedProperties })(CardBalanceAdminContainer);

